'use client';

import type { CustomMessageConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface CustomMessageSectionProps {
  config: CustomMessageConfig;
  settings: ReceiptSettings;
}

export function CustomMessageSection({ config, settings }: CustomMessageSectionProps) {
  const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }[config.alignment];
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${isNarrow ? 'py-0.5' : 'py-2'} ${alignmentClass}`}>
      <div
        style={{
          fontSize: settings.fontSize,
          fontFamily: settings.font,
          whiteSpace: 'pre-wrap',
          lineHeight: isNarrow ? 1.15 : 1.4,
          fontWeight: config.isBold ? 'bold' : 'normal',
        }}
      >
        {config.message}
      </div>

      {/* Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}



